import * as React from "react"
import { BetaBanner } from "@/components/BetaBanner"
import { MainNav } from "@/components/MainNav"

/** The signed-in app frame: sidebar on the canvas, content in a rounded card (Catalyst's sidebar layout). */
export function AppShell({ children }: { children: React.ReactNode }) {
  return (
    <div className="flex min-h-screen bg-canvas text-ink-body">
      <MainNav />
      <main className="flex min-w-0 flex-1 flex-col lg:p-2 lg:pl-0">
        <div className="flex-1 bg-page px-6 py-8 sm:px-10 lg:rounded-xl lg:shadow-xs lg:ring-1 lg:ring-ink-display/5 dark:lg:ring-white/10">
          <div className="mx-auto max-w-4xl">
            <BetaBanner />
            {children}
          </div>
        </div>
      </main>
    </div>
  )
}
